import { Button, ButtonColorEnum, ButtonSizeEnum, ModalDialog } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { Divider } from '@/components/Divider/Divider';
import { VideoPlayer } from '@/components/Video';
import { ChannelRecordingTaskType } from '@/features/recorder/types';
import { useSegments } from '@/features/segments/api/get-segments';
import { SegmentsDetailHeaderInfo } from '@/features/segments/components/SegmentsDetailHeaderInfo/SegmentsDetailHeaderInfo';
import { getFileNameFromURI } from '@/features/segments/utils';

type LastRecordingFilePreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  channelRecordingTask?: ChannelRecordingTaskType | null;
};

export function LastRecordingFilePreviewModal({
  isOpen,
  channelRecordingTask,
  onClose,
}: LastRecordingFilePreviewModalProps) {
  const { t } = useTranslation();
  const {
    data: { data: segments = [] } = {},
    isLoading: isLoadingSegments,
    isError: isErrorSegments,
  } = useSegments({
    params: {
      channelIdIn: channelRecordingTask ? [channelRecordingTask.channel_id] : undefined,
      startDatetimeGte: channelRecordingTask?.start_datetime,
      endDatetimeLte: channelRecordingTask?.end_datetime,
      limit: 1,
    },
    config: {
      enabled: isOpen,
    },
  });
  const segment = segments.at(0);

  const isEmpty = !isLoadingSegments && segments.length === 0;
  const hasError = isErrorSegments || isEmpty;

  return (
    <ModalDialog
      isOpen={isOpen}
      heading={segment ? getFileNameFromURI(segment.uri) : '#NombreArchivo'}
      className="flex h-[632px]"
      actionLabel={t('Cerrar')}
      size="large"
      lineSeparator
      linkLabel=""
      onClose={onClose}
      onAction={() => {}}
      customFooter={
        <div className="flex flex-col gap-2">
          <Divider />

          <div className="my-2 flex w-full items-center">
            <SegmentsDetailHeaderInfo segment={segment} showEnrichments hideUriName />

            <Button
              className="ml-auto w-fit"
              color={ButtonColorEnum.DEFAULT}
              onClick={onClose}
              size={ButtonSizeEnum.MD}
            >
              {t('Cerrar')}
            </Button>
          </div>
        </div>
      }
    >
      <div className="flex h-full w-full">
        <VideoPlayer
          url={segment?.presigned_url ?? ''}
          customControls
          controls={false}
          isLoading={isLoadingSegments}
          hasError={hasError}
          fullWidth
          customControlsStyles={{
            zIndex: 100,
          }}
        />
      </div>
    </ModalDialog>
  );
}
